import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useTheme } from 'styled-components';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExcelTypes } from '@nhl/excel-exporter';

import { StatsState } from '~/core/types';
import { commonMessages } from '~/utility/commonMessages';

import { generateColumnsForMeasures } from '../../statsTable/utils/generateColumns';

import { ExportIcon } from './styles';

const ExportStatsButton = () => {
    const intl = useIntl();
    const theme = useTheme();
    const statsConfig = useSelector((state: StatsState) => state.config);
    const appliedReportState = useSelector((state: StatsState) => state.playersAndTeams.report.applied);
    const dataTable = useSelector((state: StatsState) => state?.playersAndTeams.dataTable.dataset.data);
    const reportCategory = useSelector((state: StatsState) => state.playersAndTeams.report.reportCategory);

    const clickHandler = async () => {
        const { getReactTableValues, createSpreadSheet } = await import(
            /* webpackChunkName: "excel-exporter" */ '@nhl/excel-exporter'
        );

        const reportName = intl.formatMessage(commonMessages.fullReportName[appliedReportState.reportName]);
        const fileName = reportName;
        const sheetName = reportName;

        const datasetColumns = dataTable[0] ? Object.keys(dataTable[0]) : [];
        const columnDefs = generateColumnsForMeasures(
            statsConfig,
            appliedReportState,
            reportCategory,
            intl,
            datasetColumns,
            theme,
        );

        // Since we format almost all value's to string's we will convert them back to nums for Export
        const convertRowValuesToNums = (row: ExcelTypes.RowOutput): ExcelTypes.Output[] =>
            row.map((col) => (Number.isNaN(Number(col)) ? col : Number(col)));

        const rows = getReactTableValues.getRowValues(dataTable, columnDefs).map(convertRowValuesToNums);
        const headers = getReactTableValues.getHeaderValues(columnDefs);
        createSpreadSheet(fileName, sheetName, headers, rows);
    };

    return (
        <ExportIcon onClick={clickHandler}>
            <FontAwesomeIcon icon={solid('file-excel')} />
            <FormattedMessage {...commonMessages.labels.exportStats} />
        </ExportIcon>
    );
};

export default React.memo(ExportStatsButton);
